module.exports = __webpack_public_path__ + "img/bg_avatar_female_83.a59c37ae.png";